import React, { useContext } from "react"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import { useTranslation } from "react-i18next"
import KopyLogo from "../../assets/kopy-logo-square.png"
import {
	useCalculateItemCost,
	useFeatureFlagsReady,
} from "../../hooks/usePricingHooks.js"
import { Button } from "@shopify/polaris"

export const KopyBasicItem = ({ displayPrice, displayRemove, onRemove }) => {
	const { state } = useContext(GlobalStateContext)
	const { t } = useTranslation()
	const calculateItemCost = useCalculateItemCost()

	return (
		<div
			style={{
				flex: "1",
				background: "#F0F0F0",
				padding: "0.5rem",
				borderRadius: "1rem",
			}}
		>
			<div
				style={{
					display: "flex",
					gap: "0.7rem",
					alignItems: "center",
					justifyContent: "start",
				}}
			>
				<img
					className="border shadow"
					src={KopyLogo}
					style={{
						width: "2rem",
						height: "2rem",
						objectFit: "cover",
						borderRadius: "0.5rem",
					}}
				/>

				<div>
					<p
						style={{
							fontSize: "0.85rem",
							fontWeight: "700",
							color: "#333",
						}}
					>
						{t("components.billing_items.kopy_basic")}
					</p>
					<p
						style={{
							fontSize: "0.8rem",
							fontWeight: "500",
							color: "#777",
						}}
					>
						{t(
							"components.billing_items.copy_products_from_any_store",
						)}
					</p>
				</div>

				<div
					style={{
						marginLeft: "auto",
						display: "flex",
						flexDirection: "column",
						gap: "0.1rem",
						alignItems: "end",
					}}
				>
					{displayPrice && (
						<div>
							<p
								style={{
									fontSize: "0.85rem",
									fontWeight: "700",
									lineHeight: "1",
									color: "#777",
								}}
							>
								{calculateItemCost("basic", "monthly")}{" "}
								{t("account.month")}
							</p>
						</div>
					)}
					{displayRemove && (
						<Button size="slim" onClick={onRemove}>
							<span style={{ fontSize: "0.8rem" }}>
								{t("common.remove")}
							</span>
						</Button>
					)}
				</div>
			</div>
		</div>
	)
}

export const KopyProtectItem = ({ displayPrice, displayRemove, onRemove }) => {
	const { state } = useContext(GlobalStateContext)
	const { t } = useTranslation()
	const calculateItemCost = useCalculateItemCost()

	return (
		<div
			style={{
				flex: "1",
				background: "#F0F0F0",
				padding: "0.5rem",
				borderRadius: "1rem",
			}}
		>
			<div
				style={{
					display: "flex",
					gap: "0.7rem",
					alignItems: "center",
					justifyContent: "start",
				}}
			>
				<div
					className="shadow border"
					style={{
						padding: "0.3rem",
						borderRadius: "0.5rem",
						background: "#fff",
						color: "#333",
					}}
				>
					<svg
						style={{
							display: "block",
							height: "1.2rem",
							width: "1.2rem",
						}}
						viewBox="0 0 512 512"
					>
						<path
							fill="currentColor"
							d="M256 0c4.6 0 9.2 1 13.4 2.9l188.3 79.9c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0m0 66.8v378C394 378 431.1 230.1 432 141.4z"
						></path>
					</svg>
				</div>

				<div>
					<p
						style={{
							fontSize: "0.85rem",
							fontWeight: "700",
							color: "#333",
						}}
					>
						{t("components.billing_items.kopy_protect")}
					</p>
					<p
						style={{
							fontSize: "0.8rem",
							fontWeight: "500",
							color: "#777",
						}}
					>
						{t("protect.upgrade_body_short_description")}
					</p>
				</div>

				<div
					style={{
						marginLeft: "auto",
						display: "flex",
						flexDirection: "column",
						gap: "0.1rem",
						alignItems: "end",
					}}
				>
					{displayPrice && (
						<div>
							<p
								style={{
									fontSize: "0.85rem",
									fontWeight: "700",
									lineHeight: "1",
									color: "#777",
								}}
							>
								{calculateItemCost("protect", "monthly")}{" "}
								{t("account.month")}
							</p>
						</div>
					)}
					{displayRemove && (
						<Button size="slim" onClick={onRemove}>
							<span style={{ fontSize: "0.8rem" }}>
								{t("common.remove")}
							</span>
						</Button>
					)}
				</div>
			</div>
		</div>
	)
}

export const KopyPlusItem = ({ displayPrice, displayRemove, onRemove }) => {
	const { state } = useContext(GlobalStateContext)
	const { t } = useTranslation()
	const calculateItemCost = useCalculateItemCost()

	return (
		<div
			style={{
				flex: "1",
				background: "#F0F0F0",
				padding: "0.5rem",
				borderRadius: "1rem",
			}}
		>
			<div
				style={{
					display: "flex",
					gap: "0.7rem",
					alignItems: "center",
					justifyContent: "start",
				}}
			>
				<div
					className="shadow border"
					style={{
						padding: "0.3rem",
						borderRadius: "0.5rem",
						background: "#fff",
						color: "#222",
					}}
				>
					<svg
						style={{
							display: "block",
							height: "1.2rem",
							width: "1.2rem",
						}}
						viewBox="0 0 14 14"
					>
						<path
							fill="currentColor"
							fillRule="evenodd"
							d="M9.739.85c.183-.835 1.374-.84 1.564-.005l.01.04l.017.077c.22.934.975 1.648 1.922 1.812c.872.152.872 1.404 0 1.556a2.396 2.396 0 0 0-1.925 1.827l-.024.103c-.19.834-1.38.83-1.564-.007l-.02-.088a2.38 2.38 0 0 0-1.917-1.836c-.87-.152-.87-1.402 0-1.553A2.38 2.38 0 0 0 9.718.948l.014-.064zM8.658 6.398A1.294 1.294 0 0 0 7.625 5.4v7.215a2.998 2.998 0 0 0 5.204-.85a3.016 3.016 0 0 1-.778-.183c-.595-.224-1.242-.665-1.773-1.436a.625.625 0 0 1 1.03-.709c.382.555.82.839 1.183.975c.184.07.348.1.476.11l.023.002C13.61 9.85 14 8.546 14 7.457c0-.734-.177-1.458-.483-2.072l-.079.015c-.52.09-.934.484-1.051.998l-.024.102c-.448 1.967-3.255 1.955-3.686-.016zM6.375 4.615a1.963 1.963 0 0 1 0-2.127v-.52a2.618 2.618 0 0 0-4.612 1.698v.002c.039.39.198.68.382.89c.229.261.47.368.527.38a.625.625 0 1 1-.277 1.22c-.36-.083-.82-.355-1.19-.775a2.813 2.813 0 0 1-.383-.562C.312 5.526 0 6.483 0 7.457c0 .735.178 1.568.483 2.238c.08-.09.167-.172.26-.244a.625.625 0 1 1 .774.98c-.178.141-.364.444-.478.795a2.997 2.997 0 0 0 5.336 1.389v-3.67a2.69 2.69 0 0 1-1.405.585a.625.625 0 1 1-.139-1.243c.509-.056.879-.349 1.143-.734c.268-.39.384-.818.401-1.023z"
							clipRule="evenodd"
						></path>
					</svg>
				</div>

				<div>
					<p
						style={{
							fontSize: "0.85rem",
							fontWeight: "700",
							color: "#333",
						}}
					>
						{t("components.billing_items.kopy_plus")}
					</p>
					<p
						style={{
							fontSize: "0.8rem",
							fontWeight: "500",
							color: "#777",
						}}
					>
						{t(
							"components.billing_items.enhance_your_products_with_ai",
						)}
					</p>
				</div>

				<div
					style={{
						marginLeft: "auto",
						display: "flex",
						flexDirection: "column",
						gap: "0.1rem",
						alignItems: "end",
					}}
				>
					{displayPrice && (
						<div>
							<p
								style={{
									fontSize: "0.85rem",
									fontWeight: "700",
									lineHeight: "1",
									color: "#777",
								}}
							>
								{calculateItemCost("plus", "monthly")}{" "}
								{t("account.month")}
							</p>
						</div>
					)}
					{displayRemove && (
						<Button size="slim" onClick={onRemove}>
							<span style={{ fontSize: "0.8rem" }}>
								{t("common.remove")}
							</span>
						</Button>
					)}
				</div>
			</div>
		</div>
	)
}

export const AddToCartButton = ({ onClick, inCart }) => {
	return (
		<div
			onClick={onClick}
			className="shadow border"
			style={{
				padding: "0.2rem",
				borderRadius: "100%",
				background: "#fff",
				height: "fit-content",
				cursor: "pointer",
			}}
		>
			{inCart ? (
				<svg
					style={{
						display: "block",
						height: "1rem",
						width: "1rem",
						color: "#222",
					}}
					viewBox="0 0 512 512"
				>
					<path
						d="M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32zm114.9 149.1L231.8 359.6c-1.1 1.1-2.9 3.5-5.1 3.5-2.3 0-3.8-1.6-5.1-2.9-1.3-1.3-78.9-75.9-78.9-75.9l-1.5-1.5c-.6-.9-1.1-2-1.1-3.2 0-1.2.5-2.3 1.1-3.2.4-.4.7-.7 1.1-1.2 7.7-8.1 23.3-24.5 24.3-25.5 1.3-1.3 2.4-3 4.8-3 2.5 0 4.1 2.1 5.3 3.3 1.2 1.2 45 43.3 45 43.3l111.3-143c1-.8 2.2-1.4 3.5-1.4 1.3 0 2.5.5 3.5 1.3l30.6 24.1c.8 1 1.3 2.2 1.3 3.5.1 1.3-.4 2.4-1 3.3z"
						fill="currentColor"
					></path>
				</svg>
			) : (
				<svg
					style={{
						display: "block",
						height: "1rem",
						width: "1rem",
						color: "#222",
					}}
					viewBox="0 0 24 24"
				>
					<path
						fill="currentColor"
						d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2z"
					></path>
				</svg>
			)}
		</div>
	)
}

export const BillingItems = ({ toggleFromCart, cart }) => {
	const { state } = useContext(GlobalStateContext)
	const pricingReady = useFeatureFlagsReady()

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "0.5rem",
				maxWidth: "530px",
				marginLeft: "auto",
				marginRight: "auto",
			}}
		>
			<div
				style={{
					display: "flex",
					gap: "0.5rem",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<KopyBasicItem displayPrice={pricingReady} />
				<AddToCartButton
					onClick={() => toggleFromCart("basic")}
					inCart={cart.includes("basic")}
				/>
			</div>
			{!state.hasValidKopyPlusSubscription && (
				<div
					style={{
						display: "flex",
						gap: "0.5rem",
						alignItems: "center",
						justifyContent: "space-between",
					}}
				>
					<KopyPlusItem displayPrice={pricingReady} />
					<AddToCartButton
						onClick={() => toggleFromCart("plus")}
						inCart={cart.includes("plus")}
					/>
				</div>
			)}
			<div
				style={{
					display: "flex",
					gap: "0.5rem",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<KopyProtectItem displayPrice={pricingReady} />
				<AddToCartButton
					onClick={() => toggleFromCart("protect")}
					inCart={cart.includes("protect")}
				/>
			</div>
		</div>
	)
}
